// extracted by mini-css-extract-plugin
export default {"PdText":"QuestionForm_PdText__NVwWX","Link":"QuestionForm_Link__Dy6Dk"};